import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface FormData {
  displayNames: any,
  displayValues: any
}

@Component({
    selector: 'app-transaction-data-popup',
    templateUrl: './transaction-data-popup.component.html',
    styleUrls: ['./transaction-data-popup.component.scss'],
    standalone: false
})
export class TransactionDataPopupComponent implements OnInit {

  displayNames = [];

  displayValues = [];

  object = Object;

  constructor(private dialogref: MatDialogRef<TransactionDataPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: FormData) { }

  async ngOnInit() {

    this.displayNames = this.data.displayNames;

    this.displayValues = this.data.displayValues;

    console.log(this.displayNames);

    console.log(this.displayValues);

  }

  close() {

    this.dialogref.close();

  }

}